import { createRouter,createWebHistory} from 'vue-router'

import CoachDetail from './pages/coaches/CoachDetail.vue'
import CoachesList from './pages/coaches/CoachesList.vue'
import CoachRegistartion from './pages/coaches/CoachRegistartion.vue'
import ContactCoach from './pages/requests/ContactCoach.vue'
import RequestsReceived from './pages/requests/RequestsReceived.vue'
import LoginPage from './pages/auth/UserAuth.vue'
import NotFound from './pages/NotFound.vue'
import store from './store/index'


const router = createRouter({
    history:createWebHistory(),
    routes:[
         {path:'/', redirect:'/coaches'},
        {path:'/coaches', component:CoachesList},
        {path:'/coaches/:id', component:CoachDetail,

        //after adding props true : child route will get 'id' id means that dynbamic thing as prop
        props:true,
        children:[
            {path:'contact', component:ContactCoach}  //  /coaches/c1/contact
        ]},
        {path:'/register', component:CoachRegistartion,meta:{requiresAuth:true}},
        {path:'/requests', component:RequestsReceived,meta:{requiresAuth:true}},

        {path:'/auth', component:LoginPage,meta:{requiresUnauth:true}},

        {path:'/:notFound(.*)', component:NotFound},
    ]
});


router.beforeEach((to,_,next)=>{
if(to.meta.requiresAuth && !store.getters.isAuthenticated){
    next('/auth');
} else if(to.meta.requiresUnauth && store.getters.isAuthenticated){
    next('/coaches');
}
else{
    next()
}
})


export default router;